import React, { createContext, useContext, useMemo, useState } from 'react';
import { useRouter } from '@edreamsodigeo/frontend-core';

interface ItineraryTripActions {
  open: (params?: string) => void;
  close: () => void;
}
const ItineraryTripContext = createContext<boolean>(false);
const ItineraryTripActionsContext = createContext<ItineraryTripActions>({
  open: () => {},
  close: () => {},
});

const ItineraryTripProvider = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const { push } = useRouter();
  const actions = useMemo(
    () => ({
      open: (params) => {
        if (params) {
          push(`checkout_flight_summary_results/${params}/`);
        } else {
          setOpen(true);
        }
      },
      close: () => setOpen(false),
    }),
    [push, setOpen]
  );

  return (
    <ItineraryTripContext.Provider value={isOpen}>
      <ItineraryTripActionsContext.Provider value={actions}>
        {children}
      </ItineraryTripActionsContext.Provider>
    </ItineraryTripContext.Provider>
  );
};

export const useIsOpenItineraryTrip = () => useContext(ItineraryTripContext);
export const useItineraryTripActions = () =>
  useContext(ItineraryTripActionsContext);

export default ItineraryTripProvider;
